import { render, staticRenderFns } from "./MoreContentButton.vue?vue&type=template&id=683710e9&scoped=true&"
import script from "./MoreContentButton.vue?vue&type=script&lang=ts&"
export * from "./MoreContentButton.vue?vue&type=script&lang=ts&"
import style0 from "./MoreContentButton.vue?vue&type=style&index=0&id=683710e9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "683710e9",
  null
  
)

export default component.exports